import {ref, inject, type App, type Ref} from "vue"
import type {Router} from "vue-router"

type RouteEntry = {
  name: string | undefined
  fullPath: string
}

const PrevRouteSymbol = Symbol("PrevRoute")

export function createPrevRoutePlugin(router: Router) {
  const prevPage = ref<RouteEntry | null>(null)

  router.beforeEach((to, from, next) => {
    if (from.fullPath) {
      prevPage.value = {name: from.name as string | undefined, fullPath: from.fullPath}
    }
    next()
  })

  return {
    install(app: App) {
      app.provide(PrevRouteSymbol, prevPage)
    },
  }
}

// Helper for injection in components
export function usePrevRoute() {
  return inject(PrevRouteSymbol) as Ref<RouteEntry | null>
}
